import { render } from "./BaseChips.vue?vue&type=template&id=720670ea&scoped=true"
import script from "./BaseChips.vue?vue&type=script&lang=js"
export * from "./BaseChips.vue?vue&type=script&lang=js"

import "./BaseChips.vue?vue&type=style&index=0&id=720670ea&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720670ea"]])

export default __exports__